export default __webpack_public_path__ + "static/media/facebook.1cdc091c.svg";